import { type NavigationTabItem, NavigationTabs } from '@exam-management/components';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { useQBankStructure } from '@exam-management/qbs-provider';
import { usePermission } from '@shared/permissions';
import { useMemo } from 'react';

export default function QBankStructureNavigationTabs() {
  const { pageAccessibility } = useQBankStructure();
  const { permissions } = usePermission();

  const defaultTabList: NavigationTabItem[] = [
    {
      value: 'dashboard',
      label: 'Dashboard',
      disabled: !pageAccessibility.dashboard,
      path: '/qbank-structures/:structureId/dashboard',
      requiredPermission: [APP_PERMISSIONS.QBANK.DASHBOARD.VIEW],
    },
    {
      value: 'question-list',
      label: 'Question List',
      disabled: !pageAccessibility.questionList,
      path: '/qbank-structures/:structureId/qcontents',
      requiredPermission: [APP_PERMISSIONS.QBANK.QUESTION.VIEW],
    },
    {
      value: 'structure',
      label: 'Structure',
      disabled: !pageAccessibility.structure,
      path: '/qbank-structures/:structureId/structure',
      requiredPermission: [APP_PERMISSIONS.QBANK.STRUCTURE.VIEW],
    },
    {
      value: 'los',
      label: 'LOS',
      disabled: !pageAccessibility.los,
      path: '/qbank-structures/:structureId/los',
      requiredPermission: [APP_PERMISSIONS.QBANK.LOS.VIEW],
    },
    {
      value: 'settings',
      label: 'Settings',
      disabled: !pageAccessibility.settings,
      path: '/qbank-structures/:structureId/setting',
      requiredPermission: [APP_PERMISSIONS.QBANK.SETTING.VIEW],
    },
    {
      value: 'activity-log',
      label: 'Activity Log',
      disabled: !pageAccessibility.auditLog,
      path: '/qbank-structures/:structureId/activity-log',
      requiredPermission: [APP_PERMISSIONS.QBANK.AUDIT_LOG.VIEW],
    },
  ];

  const tabList = useMemo(
    () =>
      defaultTabList.filter((tab) => {
        return tab?.requiredPermission?.every((permission) => {
          return permissions.includes(permission);
        });
      }),
    [permissions, defaultTabList],
  );

  return <NavigationTabs items={tabList} navigateOptions={{ replace: true }} />;
}
